import { API_URL, getCachedSessionId } from 'src/services/common';
import { DeployProjectResponseData } from './interfaces/deployProjectResponseData.interface';
import { api } from '../../../../util/axios-instance';

export const deployProject = async (
  projectId: string
): Promise<DeployProjectResponseData | undefined> => {
  const response = await api.post<DeployProjectResponseData>(
    `${API_URL}/v1/project/${projectId}/provider/deployment/pipeline/run`,
    {},
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );
  return response.data;
};
